/**
 * Client mirror of server planFeatures — reads the feature list the
 * server computed onto tenant.features (login + /auth/me).
 *
 * Fails OPEN when the list is absent: an auth store hydrated before
 * this deploy has no features array, and DTC/legacy tenants must never
 * lose surfaces to a stale cache. The server middleware is the actual
 * enforcement layer; this is cosmetic hiding.
 */
export function tenantHasFeature(tenant, feature) {
  if (!feature) return true;
  const f = tenant?.features;
  if (!Array.isArray(f)) return true;
  return f.includes(feature);
}
